import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackClickedReturnToCurrentPositionButton.meta';

export type UseTrackClickedReturnToCurrentPositionButtonParams = {
  clip_id: string;
};

export const useTrackClickedReturnToCurrentPositionButton = () => {
  const { track } = useAnalyticsUtilities();

  const trackClickedReturnToCurrentPositionButton = useCallback(
    (params: UseTrackClickedReturnToCurrentPositionButtonParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackClickedReturnToCurrentPositionButton };
};
